<div class="no-internet" *ngIf="service.status == 'OFFLINE'">
  <img [src]="service.srcData" alt="" />
  <h2>Uh-Oh!</h2>
  <h3>Slow or no internet Connection.</h3>
  <h6>Please check your internet settings and try again</h6>
  <button (click)="retuey()">Retry</button>
</div>
